import styled from 'styled-components';

interface ContainerProps {
  gridColumn?: number;
  border?: boolean;
  focused?: boolean;
}

interface InputProps {
  error?: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 5px;
  border-radius: 6px;
  cursor: pointer;
  grid-column: ${({gridColumn}) => `span ${gridColumn ?? 12}`};
`;

export const ContainerLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(0, 0, 0, 0.6);
`;

export const Label = styled.label<InputProps>`
  font-weight: 600;
  color: ${(props) =>
    props.error ? props.theme.colors.error : props.theme.colors.text};
  cursor: pointer;
`;

export const Button = styled.button<InputProps>`
  color: ${(props) => props.theme.colors.text};
  font-weight: 600;
  display: flex;
  align-items: center;
  cursor: pointer;
  background-color: transparent;
  padding: 10px;
  border: 1px solid
    ${(props) =>
      props.error ? props.theme.colors.error : props.theme.colors.inputBorder};
  border-radius: 4px;
`;

export const Placeholder = styled.span<InputProps>`
  font-weight: 600;
  color: #adb5bd;
  background-color: transparent;
  padding: 10px;
  border: 1px solid
    ${(props) =>
      props.error ? props.theme.colors.error : props.theme.colors.inputBorder};
  border-radius: 4px;
`;
